import type { ReactNode } from 'react'

import type { GridLayoutItemProps } from '../GridLayout.types'

/**
 * Placement marker for a grid cell. {@link GridLayoutView} reads `colSpan` /
 * `minWidth` and places `children` on the shared CSS grid — this component
 * does not render its own layout box.
 */
export const GridLayoutItem = ({ children }: GridLayoutItemProps): ReactNode =>
  children

GridLayoutItem.displayName = 'GridLayoutItem'
